
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_8dz0f_181",
  "refresh": "awsui_refresh_2qdw9_8dz0f_217",
  "root-no-actions": "awsui_root-no-actions_2qdw9_8dz0f_217",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_8dz0f_220",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_8dz0f_220",
  "root-has-description": "awsui_root-has-description_2qdw9_8dz0f_220",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_8dz0f_229",
  "main": "awsui_main_2qdw9_8dz0f_239",
  "no-wrap": "awsui_no-wrap_2qdw9_8dz0f_249",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_8dz0f_255",
  "actions": "awsui_actions_2qdw9_8dz0f_263",
  "actions-centered": "awsui_actions-centered_2qdw9_8dz0f_268",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_8dz0f_271",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_8dz0f_275",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_8dz0f_279",
  "title": "awsui_title_2qdw9_8dz0f_295",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_8dz0f_300",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_8dz0f_307",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_8dz0f_313",
  "virtual-space": "awsui_virtual-space_2qdw9_8dz0f_334",
  "info": "awsui_info_2qdw9_8dz0f_340",
  "description": "awsui_description_2qdw9_8dz0f_344",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_8dz0f_351",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_8dz0f_355",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_8dz0f_362",
  "heading": "awsui_heading_2qdw9_8dz0f_373",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_8dz0f_384",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_8dz0f_389",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_8dz0f_394",
  "heading-text": "awsui_heading-text_2qdw9_8dz0f_400",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_8dz0f_403",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_8dz0f_411",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_8dz0f_419",
  "counter": "awsui_counter_2qdw9_8dz0f_428"
};
  